import React from 'react';

import { Modal } from '@opendoor/bricks';

import './DeclineModalStyle.less';

export interface IDeclineModalProps {
  closeModal: () => void;
  isOpen: boolean;
  offerTooLowFeedbackEnabled?: boolean;
  onDeclineSubmit: (declineReasons: Set<string>, feedbackText: string) => void;
}

interface IState {
  declineReasons: Set<string>;
  feedbackText: string;
  sendInProgress: boolean;
}

const DECLINE_OPTIONS = {
  fees_too_high: 'Fees are too high',
  not_ready_to_sell: 'I’m not ready to sell',
  offer_too_low: 'Offer is too low',
  other: 'Other',
};

class DeclineModal extends React.Component<IDeclineModalProps, IState> {
  public static defaultProps = {
    offerTooLowFeedbackEnabled: true,
  };

  public state = {
    declineReasons: new Set(),
    feedbackText: '',
    sendInProgress: false,
  };

  public render() {
    const { offerTooLowFeedbackEnabled, isOpen, closeModal } = this.props;
    const feedbackPlaceholder = 'For example: "I recently upgraded to granite countertops..."';
    const { declineReasons, feedbackText, sendInProgress } = this.state;
    const shouldDisableSubmit = declineReasons.size === 0 || sendInProgress;

    return (
      <Modal isOpen={isOpen} onRequestClose={closeModal} className="od-offer-decline-modal">
        <div className="prose">
          <h3>Decline your Opendoor offer</h3>
          <p>
            You have a lot of options when it comes to selling your home, and we appreciate your
            interest in Opendoor.
          </p>
        </div>

        <form onSubmit={this.onSubmit}>
          <h6 className="feedback-section-header">
            What about your Opendoor offer wasn’t right for you?
          </h6>
          <div className="row medium-margin-bottom">
            {Object.keys(DECLINE_OPTIONS).map(this.renderDeclineOption)}
          </div>

          <h6 className="feedback-section-header">Notes or other feedback (optional):</h6>
          <textarea
            className="feedback-textarea"
            placeholder={feedbackPlaceholder}
            rows={5}
            value={feedbackText}
            onChange={this.onFeedbackChange}
          />

          {offerTooLowFeedbackEnabled &&
            declineReasons.has('offer_too_low') &&
            this.renderOfferTooLowFeedbackForm()}

          <button
            className="button submit-button primary od-xhr-progress"
            disabled={shouldDisableSubmit}
          >
            Decline offer
          </button>
        </form>
      </Modal>
    );
  }

  private renderOfferTooLowFeedbackForm() {
    return (
      <div className="feedback-banner box text-small.medium-margin-bottom">
        If you believe we misvalued your home, you can send us photos of information about your home
        that we can use to reassess your offer.&nbsp;
        <a className="cursor-pointer">
          {/* TODO: I didn't implement this because we didn't need it for the ODA flow. If you are implementing the
              core flow, please implement this callback, or replace it with the correct href. */}
          Click here to send us additional information.
        </a>
      </div>
    );
  }

  private onFeedbackChange = e => {
    this.setState({ feedbackText: e.target.value });
  };

  private renderDeclineOption = declineOptionKey => {
    return (
      <div className="col-sm-6 col-xs-12" key={declineOptionKey}>
        <div className="checkbox-big-btn-group">
          <label className="checkbox-big-btn">
            <input
              type="checkbox"
              value={declineOptionKey}
              checked={this.state[declineOptionKey]}
              onChange={this.handleDeclineOptionChange}
            />
            <span>{DECLINE_OPTIONS[declineOptionKey]}</span>
          </label>
        </div>
      </div>
    );
  };

  private onSubmit = e => {
    e.preventDefault();
    const { declineReasons, feedbackText } = this.state;
    this.props.onDeclineSubmit(declineReasons, feedbackText);
  };

  private handleDeclineOptionChange = e => {
    const declineOptionKey = e.target.value;
    const { declineReasons } = this.state;

    if (e.target.checked) {
      declineReasons.add(declineOptionKey);
    } else {
      declineReasons.delete(declineOptionKey);
    }

    this.setState({ declineReasons });
  };
}

export default DeclineModal;
